import axios from '../axios';
// eslint-disable-next-line import/order
import useAxios, { configure } from 'axios-hooks';

configure({ axios });

export default function useGetStockCodesFromWires(wires, limit) {
  const searchQueryId = window.Livewire?.request?.searchQuery?.id;

  return useAxios({
    cache: { ignoreCache: true },
    url: '/api/v1/stock_codes',
    method: 'GET',
    params: { wires, search_query_id: searchQueryId, top: limit },
  }, { manual: true });
}

export function getWireStockCodes(wireId) {
  return axios.get(`/api/v1/wire/${wireId}/stock_codes`, { cache: { ignoreCache: true } });
}
